module.exports = __webpack_public_path__ + "img/bus.858e11b8.svg";